export default __webpack_public_path__ + "static/image-47-8532c38f5f54c82a07a994b8065e7600.jpg";